import { fetchBaseQuery } from "@reduxjs/toolkit/query"

export default function fetchQuery() {
  return fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_BASE_URL,
    prepareHeaders: (headers) => {
      headers.set("Content-Type", "application/json")
      headers.set("Authorization", `Basic ${process.env.REACT_APP_API_KEY}`)
      return headers
    },
  })
}
